import React from 'react';
import { useNavigate } from 'react-router-dom';

const PricingCTA = () => {
  const navigate = useNavigate();

  return (
    <section style={{ padding: '100px 48px', background: 'var(--color-background)', position: 'relative', overflow: 'hidden' }}>
      {/* Geometric accents */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(20deg)', width: '700px', height: '700px', border: '1px solid rgba(255,87,34,0.04)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'rgba(224,228,232,0.06)' }} />
      <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
          {/* Diagonal accent */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
            <div style={{ width: '48px', height: '3px', background: '#FF5722', transform: 'skewX(-20deg)' }} />
            <div style={{ width: '24px', height: '3px', background: 'rgba(255,87,34,0.3)', transform: 'skewX(-20deg)', marginLeft: '6px' }} />
          </div>

          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '42px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.02em', lineHeight: 1.1, marginBottom: '20px' }}>
            Klar til å spare penger
            <span style={{ display: 'block', color: '#FF5722' }}>på norske veier?</span>
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', lineHeight: 1.7, marginBottom: '48px', maxWidth: '520px', margin: '0 auto 48px' }}>
            Bli med over 10 000 norske sjåfører som allerede sparer penger med Veiassistent. Start gratis i dag — ingen kredittkort nødvendig.
          </p>

          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => navigate('/register')}
              style={{
                background: '#FF5722',
                border: '2px solid #FF5722',
                borderRadius: '2px',
                padding: '16px 40px',
                fontFamily: 'var(--font-heading)',
                fontSize: '14px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: '#FFFFFF',
                cursor: 'pointer',
                transition: 'background 200ms ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#E64A19'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#FF5722'; }}
            >
              Kom i gang gratis
            </button>
            <button
              onClick={() => navigate('/contact')}
              style={{
                background: 'transparent',
                border: '2px solid rgba(0,79,152,0.5)',
                borderRadius: '2px',
                padding: '16px 40px',
                fontFamily: 'var(--font-heading)',
                fontSize: '14px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--color-foreground)',
                cursor: 'pointer',
                transition: 'all 200ms ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#004F98'; e.currentTarget.style.color = '#004F98'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(0,79,152,0.5)'; e.currentTarget.style.color = 'var(--color-foreground)'; }}
            >
              Kontakt oss
            </button>
          </div>

          {/* Trust indicators */}
          <div style={{ display: 'flex', gap: '32px', justifyContent: 'center', marginTop: '48px', flexWrap: 'wrap' }}>
            {[
              { icon: '🔒', text: 'Ingen binding' },
              { icon: '↩', text: 'Kanseller når som helst' },
              { icon: '🛡', text: 'Sikker betaling' },
            ]?.map(item => (
              <div key={item?.text} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '16px' }}>{item?.icon}</span>
                <span style={{ fontFamily: 'var(--font-caption)', fontSize: '13px', fontWeight: 500, color: 'var(--color-muted-foreground)', letterSpacing: '0.04em' }}>{item?.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingCTA;
